import React, { useEffect, useState } from 'react';
import CutButton from '../../generic-components/customCutButton/CutButton';
import { useLocation, useNavigate } from 'react-router-dom';

const sidebarItems = [
    { id: 1, title: 'Dashboard', url: '/' },
    { id: 2, title: 'My Application', url: '/application' },
    { id: 3, title: 'Profile', url: '/profile' }
];

const Sidebar = () => {
    const [active, setActive] = useState(1);
    const navigate = useNavigate();
    const location = useLocation();
    const handleChangeItem = (item: any) => {
        setActive(item?.id);
        navigate(item?.url);
    };

    // useEffect(() => {
    //     navigate('/');
    // }, []);

    useEffect(() => {
        const currentHash = location.pathname;
        const current = sidebarItems.find((item) => item.url === currentHash);
        if (current) setActive(current.id);
    }, [location]);

    return (
        <aside className="sidebar-container">
            {sidebarItems.map((item) => (
                <CutButton
                    key={item.id}
                    title={item.title}
                    buttonType="button"
                    disabled={false}
                    onClick={() => handleChangeItem(item)}
                    primaryButtonStyle={
                        active === item.id
                            ? {
                                  '--parent-bg-background': '#003764',
                                  '--bg-cut-background': '#003764',
                                  color: '#fff'
                              }
                            : {
                                  '--parent-bg-background': '#ffffff',
                                  '--bg-cut-background': '#ffffff',
                                  color: '#003764',
                                  border: '2px solid #003764'
                              }
                    }
                />
            ))}
        </aside>
    );
};

export default Sidebar;
